import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Card from 'pf9-ui-components/built/elements/card/Card'
import CardBody from 'pf9-ui-components/built/elements/card/CardBody'
import Text from 'core/elements/Text'
import clsx from 'clsx'
import SimpleLink from 'pf9-ui-components/built/components/SimpleLink'

interface VmwareConfigCardProps {
  className?: string
}

export default function VmwareConfigCard({ className }: VmwareConfigCardProps) {
  const classes = useStyles()
  return (
    <Card className={clsx(classes.vmwareConfigCard, className)} withCustomBody>
      <CardBody className={classes.vmwareConfigCardBody}>
        <div className={classes.vmwareConfigCardHeader}>
          <Text variant="subtitle1">VMware Configuration</Text>
          <SimpleLink
            label="Activity Log"
            textVariant="caption1"
            icon="chevron-right"
            onClick={null}
          >
            Activity Log
          </SimpleLink>
        </div>
        <div className={classes.detailsContainer}>
          <div className={clsx(classes.infoBox, classes.borderRight)}>
            <Text variant="body2">Version</Text>
            <Text variant="subtitle2">7.03 U3</Text>
          </div>
          <div className={clsx(classes.infoBox, classes.borderRight)}>
            <Text variant="body2">Version Policy</Text>
            <Text variant="subtitle2">Automatic, latest stable</Text>
          </div>
          <div className={clsx(classes.infoBox)}>
            <Text variant="body2">Maintenance Window</Text>
            <Text variant="subtitle2">Sunday, 8-10 am CST</Text>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  vmwareConfigCardBody: {
    display: 'grid',
    gridTemplateRows: 'auto max-content',
    gap: theme.spacing(2),
  },
  vmwareConfigCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  arrow: {
    fontSize: 12,
  },
  detailsContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
    gap: theme.spacing(2),
  },
  infoBox: {
    display: 'grid',
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
    marginBottom: theme.spacing(1),
  },
  borderRight: {
    borderRight: `1px solid ${theme.palette.grey[300]}`,
  },
}))
